angular.module("app").directive("tchFileInput", ["$parse",function ($parse) {
	return {
		restrict: "A",
		link: function(scope, element, attrs) {
			var model = $parse(attrs.tchFileInput);
			var modelSetter = model.assign;

			element.bind("change", function(){
				scope.$apply(function(){
					modelSetter(scope, element[0].files[0]);
				});
			});
		}
	};
}]);